import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'office-ui-fabric-react';
import { RichTextField } from '../../../components/RichTextField';

const TextWithTemplates = ({
  textValue,
  templateOptions,
  onChangeDropdown,
  onChangeText,
  setIsHearingAnswered,
  placeHolderText,
  labelText,
  disableTemplates,
}) => {
  const { t: translator } = useTranslation();
  const [initialValue, setInitialValue] = useState(textValue);

  const onChangeTextLocal = (value) => {
    if (value === textValue) {
      return;
    }
    onChangeHearingAnswer(value);
    onChangeText(value);
  };

  const onChangeDropDownLocal = (_, value) => {
    const tempValue = value && value?.content ? value.content : value.text;
    setInitialValue(tempValue);
    onChangeDropdown(_, value);
    onChangeHearingAnswer(tempValue);
  };

  const onChangeHearingAnswer = (value) => {
    setIsHearingAnswered?.(!!value);
  };

  return (
    <div className="create-hearing-form-field">
      {disableTemplates ? null : (
        <Dropdown
          placeholder={translator('global.noneSelected')}
          label={labelText}
          onChange={onChangeDropDownLocal}
          options={templateOptions}
          styles={dropdownStylesHalf}
          disabled={templateOptions.length === 0}
        />
      )}
      <RichTextField
        initialValue={initialValue}
        onChange={onChangeTextLocal}
        placeholder={placeHolderText}
      />
    </div>
  );
};

export { TextWithTemplates };

const dropdownStylesHalf = {
  root: { width: '50%', padding: '7px 0' },
  label: {
    fontSize: '14',
    fontWeight: '500',
    color: '#333333',
  },
};
